<template>
	<div class="footer" :class="$i18n.locale">
		<div class="wrap">
			<img src="@/assets/img/bai_logo.png" class="logo" alt="">
			<div class="nav_flex">
				<div class="nav">
					<div class="li">
						<div class="name" @click="router_url('/tansuo')">{{$t('探索')}}</div>
						<div class="p1" @click="router_url('/tansuo?elementId=womendeyuanjing')">{{$t('我们的愿景')}}</div>
						<div class="p1" @click="router_url('/tansuo?elementId=womendelishi')">{{$t('我们的历史')}}</div>
						<div class="p1" @click="router_url('/tansuo?elementId=VRtanxiao')">{{$t('VR探校')}}</div>
						<div class="p1" @click="router_url('/tansuo?elementId=xiaoyuansheshishebei')">{{$t('校园设施设备')}}</div>
					</div>
					<div class="li">
						<div class="name" @click="router_url('/zhaosheng')">{{$t('招生')}}</div>
						<div class="p1" @click="router_url('/zhaosheng?elementId=yuyuetanxiao')">{{$t('预约探校')}}</div>
						<div class="p1" @click="router_url('/zhaosheng?elementId=xuexiaoshoufeibiaozhun')">{{$t('学校收费标准')}}</div>
						<div class="p1" @click="router_url('/zhaosheng?elementId=tuifeizhengce')">{{$t('退费政策')}}</div>
						<div class="p1" @click="router_url('/zhaosheng?elementId=qa')">{{$t('招生问答')}}</div>
					</div>
					<div class="li">
						<div class="name" @click="router_url('/xiaoxue')">{{$t('小学')}}</div>
						<div class="p1" @click="router_url('/xiaoxue?elementId=hexinkecheng')">{{$t('核心课程')}}</div>
						<div class="p1" @click="router_url('/xiaoxue?elementId=ronghekecheng')">{{$t('IB-PBL融合课程')}}</div>
						<div class="p1" @click="router_url('/xiaoxue?elementId=suzhituozhantixi')">{{$t('素质拓展体系')}}</div>
					</div>
					<div class="li">
						<div class="name" @click="router_url('/chuzhong')">{{$t('初中')}}</div>
						<div class="p1" @click="router_url('/chuzhong?elementId=xingzoudeketang')">{{$t('行走的课堂')}}</div>
						<div class="p1" @click="router_url('/chuzhong?elementId=duoyuanshengxuetongdao')">{{$t('多元升学通道')}}</div>
					</div>
					<div class="li">
						<div class="name" @click="router_url('/guojigaozhong')">{{$t('国际高中')}}</div>
						<div class="p1" @click="router_url('/guojigaozhong?elementId=huangjinshizipeizhi')">{{$t('黄金师资配置')}}</div>
						<div class="p1" @click="router_url('/guojigaozhong?elementId=guojiban')">{{$t('IP国际班')}}</div>
						<div class="p1" @click="router_url('/guojigaozhong?elementId=shengxuebaogao')">{{$t('升学报告')}}</div>
					</div>
					<div class="li">
						<div class="name" @click="router_url('/changchengshuyuan')">{{$t('长城书院')}}</div>
						<div class="p1" @click="router_url('/changchengshuyuan?elementId=guonakecheng')">{{$t('国内课程')}}</div>
						<div class="p1" @click="router_url('/changchengshuyuan?elementId=shuangguihuzhuan')">{{$t('双轨互转')}}</div>
						<div class="p1" @click="router_url('/changchengshuyuan?elementId=shuangyufunenjihua')">{{$t('双语赋能计划')}}</div>
					</div>
					<div class="li">
						<div class="name" @click="router_url('/laihua')">{{$t('来华')}}</div>
						<div class="p1" @click="router_url('/laihua?elementId=zizhiyubaozhang')">{{$t('资质与保障')}}</div>
						<div class="p1" @click="router_url('/laihua?elementId=zhongwenyuxueshu')">{{$t('中文与学术')}}</div>
						<div class="p1" @click="router_url('/laihua?elementId=chenggonganli')">{{$t('成功案例')}}</div>
					</div>
					<div class="li">
						<div class="name" @click="router_url('/news_info')">{{$t('新闻')}}</div>
					</div>
				</div>
				<div class="imgs_flex">
					<div class="imgs">
						<img src="@/assets/img/weixin.png" class="img" alt="">
						<div class="tanchu">
							<div class="tit">{{$t('扫码关注我们的公众号')}}</div>
							<div class="ul_img">
								<div class="ul_img_li">
									<img src="@/assets/img/weixin_erweim1.png" class="erwei" alt="">
									<div class="p1">{{$t('北京中加学校')}}</div>
								</div>
								<div class="ul_img_li">
									<img src="@/assets/img/weixin_erweim2.png" class="erwei" alt="">
									<div class="p1">{{$t('北京通州华仁学校')}}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="imgs">
						<img src="@/assets/img/weiqq.png" class="img" alt="">
						<div class="tanchu">
							<div class="tit">{{$t('扫码关注视频号')}}</div>
							<div class="ul_img">
								<div class="ul_img_li">
									<img src="@/assets/img/weixin_erweim3.png" class="erwei" alt="">
								</div>
							</div>
						</div>
					</div>
					<div class="imgs">
						<img src="@/assets/img/xiaohongshu.png" class="img" alt="">
						<div class="tanchu">
							<div class="tit">{{$t('扫码在小红书里找到我们')}}</div>
							<div class="ul_img">
								<div class="ul_img_li">
									<img src="@/assets/img/weixin_erweim4.png" class="erwei" alt="">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="copyright">
				<div class="left">{{$t('电话')}}  {{$t('地址')}}<i class="el-icon-location" @click="ditu"></i>{{$t('版权')}}</div>
				<div class="right">
					<a href="//api.bccsc.com.cn/uploads/apk/bccsc.apk" target="_blank" class="privacy" download="bccsc.apk">{{$t('APP下载')}}</a>
					<div class="privacy" @click="router_url('/yinsizhengce')">{{$t('隐私政策')}}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'footer_html',
	data(){
		return{

		}
	},
	mounted(){

	},
	methods:{
		ditu(){
			window.open('https://map.baidu.com/search/%E5%8C%97%E4%BA%AC%E5%B8%82%E4%B8%AD%E5%8A%A0%E5%AD%A6%E6%A0%A1/@12991096.000572504,4831123.599541049,16.03z?querytype=s&da_src=shareurl&wd=%E5%8C%97%E4%BA%AC%E5%B8%82%E4%B8%AD%E5%8A%A0%E5%AD%A6%E6%A0%A1&c=131&src=0&pn=0&sug=0&l=13&b=(12965662.849617181,4820144.192432803;13013544.582978664,4845415.1072624745)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2')
		}
	}
}
</script>
<style scoped>
	.el-icon-location{
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/footer.vue